import isFunction from 'lodash/isFunction';
import { getReportType } from '@/reports/report-utils';

export function sendObjectMetadata (objectId: string, objectProperty: string, metadata: Record<string, unknown>): void {
    if (!objectId || !objectProperty) return;
    if (!isFunction(window.pendo?.objectMetadata)) return;

    window.pendo.objectMetadata(objectId, objectProperty, metadata);
}

export function sendReportObjectMetadata (report: {
    id: string;
    name?: string;
    type?: string;
    kind?: string;
    definition?: { type?: string };
    shared?: boolean;
    subscriptionSharing?: { permission: string };
}): void {
    if (!report?.id) return;

    let subscriptionSharingPermission: string | undefined = report.subscriptionSharing?.permission;
    if (!subscriptionSharingPermission && report.shared === true) subscriptionSharingPermission = 'view';
    if (!subscriptionSharingPermission && report.shared === false) subscriptionSharingPermission = 'restricted';
    const sharingIsKnown = typeof subscriptionSharingPermission === 'string';
    let isShared = report.shared;
    if (isShared === undefined && sharingIsKnown) {
        isShared = subscriptionSharingPermission !== 'restricted';
    }

    sendObjectMetadata(report.id, 'reportId', {
        name: report.name,
        reportType: getReportType(report),
        isShared,
        subscriptionSharingPermission,
        sharedUserCount: sharingIsKnown ? 0 : undefined,
        sharedTeamCount: sharingIsKnown ? 0 : undefined,
    });
}

export function sendDashboardObjectMetadata (dashboard: {
    id: string;
    name?: string;
    isShared?: boolean;
    usesDashboardTemplate?: boolean;
    subscriptionSharing?: string | { permission: string };
    userSharing?: Array<{ sharedWithUser?: { id?: string | number } | null }>;
    teamSharing?: Array<{ sharedWithTeam?: { id?: string | number } | null }>;
}): void {
    if (!dashboard?.id) return;

    const subscriptionSharingPermission = typeof dashboard.subscriptionSharing === 'string'
        ? dashboard.subscriptionSharing
        : dashboard.subscriptionSharing?.permission;

    sendObjectMetadata(dashboard.id, 'dashboardId', {
        name: dashboard.name,
        isShared: dashboard.isShared,
        usesDashboardTemplate: dashboard.usesDashboardTemplate,
        subscriptionSharingPermission,
        sharedUserCount: dashboard.userSharing?.length,
        sharedTeamCount: dashboard.teamSharing?.filter(({ sharedWithTeam }) => sharedWithTeam !== null).length,
    });
}
